module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.hasAddress) ? _c('div', {
    staticClass: "mapView"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(0), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', [_c('small', {
    staticClass: "text-muted"
  }, [_vm._v(_vm._s(_vm.$t('events.yourAddress')) + "  ("), _c('a', {
    attrs: {
      "role": "button"
    },
    on: {
      "click": _vm.toggleUserAddressEditing
    }
  }, [_vm._v(_vm._s(_vm.$t('globals.edit')))]), _vm._v(")")]), (_vm.userAddress.length > 0) ? _c('p', [_vm._v(_vm._s(_vm.userAddress))]) : _c('p', [_vm._v(_vm._s(_vm.$t('events.addressToDefined')))])])]), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', [_c('small', {
    staticClass: "text-muted"
  }, [_vm._v(_vm._s(_vm.$t('events.address'))), (_vm.canEditAddress) ? [_vm._v("  ("), _c('a', {
    attrs: {
      "role": "button"
    },
    on: {
      "click": _vm.emitEdit
    }
  }, [_vm._v(_vm._s(_vm.$t('globals.edit')))]), _vm._v(")")] : _vm._e()], 2), _c('p', [_vm._v(_vm._s(_vm.address))])])])]), (_vm.isUserAddressEditing) ? [(_vm.userAddress.length == 0) ? _c('div', {
    staticClass: "alert alert-info"
  }, [_vm._v(_vm._s(_vm.$t('events.needYourAddress')))]) : _vm._e(), _c('user-address-edition', {
    attrs: {
      "btnText": _vm.$t("events.showPath")
    },
    on: {
      "saved": _vm.userAddressSaved
    }
  })] : [_c('div', {
    staticClass: "directions"
  }), _c('div', {
    staticClass: "pull-right"
  }, [_c('a', {
    staticClass: "btn btn-xs",
    attrs: {
      "href": _vm.gmapsUrl,
      "target": "_blank",
      "rel": "noopener"
    }
  }, [_vm._v(_vm._s(_vm.$t('events.toGoogleMaps')) + " "), _c('i', {
    staticClass: "fa fa-long-arrow-right"
  })])])]], 2)])]) : _c('div', {
    staticClass: "padding"
  }, [_c('div', {
    staticClass: "text-center"
  }, [_c('h5', [_vm._v(_vm._s(_vm.$t("events.noAddress")))]), _c('br'), (_vm.canEditAddress) ? _c('a', {
    staticClass: "btn btn-primary",
    on: {
      "click": _vm.emitEdit
    }
  }, [_vm._v(_vm._s(_vm.$t('events.defineAnAddress')))]) : _vm._e()])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-8"
  }, [_c('div', {
    staticClass: "map"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-69052874","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/MapView.vue
// module id = 889
// module chunks = 13